import { baseAPI } from '~shared/api/base-api';

interface ReportingClassGenreReportParams {
  sessionId?: string;
  format?: string;
}

export const reportingClassGenreReportAPI = async (
  params?: ReportingClassGenreReportParams,
) => {
  const response = await baseAPI.get<string>('reporting/class-genre-report', {
    params,
    responseType: 'text',
  });
  return response.data;
};
